export const defaultFormTemplate = {
      task_id: null,
      subject: null,
      description: null,
      customer_id: null,
      customerName: null,
      assignee: null,
      related_to:null,
      task_status: null,
      task_type: null,
      task_priority: null,
      task_repeat: "no",
      start_date: null,
      completed_date: null,
      created_by: null,
      modified_by: null,
      created_date: null,
      modified_date: null,
      tasksWatchers: null,
      tasks_watchersID: null,
      repeat_every: null,
      repeat_on: "daily",
      monthly: null,
      days: null,
      ends: null,
      end_on_date: null,
      record_type: "task",
      attachment_file: null,
      product: null,
      project_id:null,
      title:null,
      day:null,
      hours:null,
      minute:null,
      estimate_time:null,
      menuId:'',
      status: 'active'};

export const defaultColumns = [
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"task_id","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
 
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"subject","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
 
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"customer_id","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
 
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"assignee","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
];

export const  skipFields=[];
export const  filterSkipFields=[];

export const validationRules = {
          subject: { required: true, maxLength: 100 },
          // due_date: { required: true },
          // description: { required: false }
        };
export const columnLabels = {
        subject:'Title',
        customer_id: 'Customer Name',
        email: 'Customer Email',
        company_id: 'Company Name',
        project_id: 'Project',
        task_type: 'Task Type',
        task_status: 'Task Status',
        assignee:'Assignee',
        start_date:'Start Date',
        due_date:'End Date',
      };
export  const fieldOverrides = {
            description:{
              type:'editor',
              props:{
                showEditorInitially:true,
              }
            },
            assignee: {
              type: 'smartSelectInput',
              config: {
                label: '',
                type: 'admin',
                source: 'admin',
                valueKey:'adminID',
                placeholder: 'Select Assignee',
                check: 'name',
                getLabel: (item) => `${item.name}`,
                getValue: (item) => item.adminID,
                allowAddNew: true,preload: true,cache: true,showRecent: true,multi:false,
                list: 'name,adminID'
              }
            },
            related_to:{
              type: 'date',
            },
            customer_id: {
              type: 'smartSelectInput',
              config: {
                label: 'Customer',
                type: 'customer',
                source: 'customer',
                valueKey:'customer_id',
                placeholder: 'Select Customer',
                check: 'name',
                getLabel: (item) => `${item.name}`,
                getValue: (item) => item.customer_id,
                allowAddNew: true,preload: true,cache: true,showRecent: true,multi:false,
                list: 'name,customer_id,type'
              }
            },
            task_type: {
              type: 'smartSelectInput',
              config:{label: '',type: 'category',source: 'task_type',placeholder: 'Select Task Type',allowAddNew: true,preload: true,cache: true,showRecent: true,getLabel: (item) => `${item.categoryName}`,getValue: (item) => item.category_id,},
              onChangeTrigger: {
                value: 'new',
                action: 'callStoreMethod',
                storeKey: 'createProduct',
                method: 'openProductCreate',
                payload: (formData) => ({
                  relatedTo: formData.name || 'Unknown',
                  module: 'Product'
                })
              }
            },
            task_status: {
              type: 'smartSelectInput',
              config:{label: '',type: 'category',source: 'task_status',placeholder: 'Select Task Status',allowAddNew: true,preload: true,cache: true,showRecent: true,getLabel: (item) => `${item.categoryName}`,
                getValue: (item) => item.category_id,}
            },
            task_priority: {
              type: 'smartSelectInput',
              config:{label: '', type: 'category',source: 'task_priority',placeholder: 'Select Task Priority',allowAddNew: true,preload: true,cache: true,showRecent: true,getLabel: (item) => `${item.categoryName}`,
                getValue: (item) => item.category_id,}
            },
            task_repeat:{
              type: 'dropdown',
              label: 'Task Repeat',
              options: [
                  { value: 'no', label: 'No' },
                  { value: 'daily', label: 'Daily' },
                  { value: 'mon_to_fir', label: 'Mon To Fir' },
                  { value: 'weekend', label: 'Weekend' },
                  { value: 'custom', label: 'Custom' },
                ]
              },
              
            start_date:{
                type:'date',
                defaultToday: false,
                preventPast: true, // disallow selecting past dates
                // preventFuture: true // disallow selecting future dates
                //limitTo: 'month' // 'week' or 'year' also supported
               // preventBefore: '2025-06-10'
                //preventAfter: '2025-12-31'
               
            },
            due_date:{
                type:'date',
                defaultToday: false,
                preventPast: true, // disallow selecting past dates
                // preventFuture: true // disallow selecting future dates
                //limitTo: 'month' // 'week' or 'year' also supported
                //preventBefore: '2025-06-10'
                //preventAfter: '2025-12-31'
               
            },
            status: {
              type: 'checkbox',
              label: 'Status',
              options: [
                  { value: 'active', label: 'Active' },
                  { value: 'inactive', label: 'Active' }
                ]
              },
          };

          
export const directSchemaTemplate = [
  { Field: 'subject', Type: 'varchar' },
  { Field: 'description', Type: 'editor' },
  { Field: 'customer_id', Type: 'smartSelectInput' },
  { Field: 'assignee', Type: 'smartSelectInput' },
  { Field: 'related_to', Type: 'dropdown' },
  { Field: 'task_status', Type: 'smartSelectInput' },
  { Field: 'task_type', Type: 'smartSelectInput' },
  { Field: 'task_priority', Type: 'smartSelectInput' },
  { Field: 'task_repeat', Type: 'dropdown' },
  { Field: 'start_date', type: 'date' },
  { Field: 'due_date', type: 'date' },
  { Field: 'product', Type: 'varchar' },
  { Field: 'project_id', Type: 'varchar' },
  { Field: 'status', Type: 'radio' },
];
 export const layout = [
  {
    type: 'customSplit', // Special layout trigger
    left: [ { field: 'subject'},{ field: 'description'},{customFieldsPlaceholder:true},{addcustomFieldBtn:true},{ custom: 'comments_history' }],
    right: [ { field: 'start_date'},
        { field: 'due_date' },
        { field: 'task_type'},
        { field: 'task_status'},
        { field: 'task_priority'},
       { field: 'assignee'}, { field:'task_repeat'},{ custom: 'custom_task_repeat',
             showWhen: {
          field: 'task_repeat',
          value: 'custom'
        }
        },]
    },
  ];
export const infoIcons = {
  task_repeat: { show: true, text: 'Select how often this task should repeat. Useful for automating follow-ups, reports, or routine actions.' },
  //due_date: { show: true, text: 'Select the final deadline for this task.' },
  // ...
};